/* @sravni/react-design-system version 0.2.55 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import '../../Typography/index.js';
import modules_3fa78883 from '../styles/Breadcrumb.module.less.js';
import { Link } from '../../Typography/src/Link.js';

/**
 * @description Breadcrumb Item component.
 *
 * @component
 * @example
 * ```jsx
 * <Breadcrumb.Item>Home</Breadcrumb.Item>
 * ```
 */
var Item = React.forwardRef(function (props, ref) {
    var className = props.className, children = props.children, restProps = __rest(props, ["className", "children"]);
    var cx = useStyles(modules_3fa78883);
    return (React.createElement(Link, __assign({ ref: ref, className: cx(className, 'item') }, restProps, { color: "black" }), children));
});
Item.defaultProps = {};

export default Item;
//# sourceMappingURL=BreadcrumbItem.js.map
